module.exports = __webpack_public_path__ + "img/saleicon.194a6150.png";